import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';
import KitoMascot from '../../components/Mascot';
import styles from './styles.module.css';
import KitoCard from '../../components/DataDisplay/Card';
import VaccineGuardian from '../../assets/vaccine-guardian.svg';
import Milestone from '../../assets/milestone.svg';
import BaseLayout from '../../commons/BaseLayout';

const VERSION_STORAGE_KEY = '@kitoApp/version';

export default function StaticChildProgress() {
  const { t } = useTranslation();
  const [activeVersion, setActiveVersion] = useState(
    () => globalThis.localStorage.getItem(VERSION_STORAGE_KEY) || 'Adult'
  );
  const navigate = useNavigate();

  return (
    <BaseLayout header headerLogo onVersionChange={setActiveVersion} sidebar >
      {activeVersion === 'Child' ? (
        <Navigate to="/homepage" replace />
      ) : (
        <div className={styles.childProgressStaticPage}>
          <KitoMascot mascotWidth={120} image="whatToDo" speech>
            {t('staticPages.childProgress.greeting')}
          </KitoMascot>
          <div className={styles.childProgressStaticPage__options}>
            <h3 className={styles.childProgressStaticPage__options__title}>{t('staticPages.childProgress.title')}</h3>
            <KitoCard
              fullWidth
              image={Milestone}
              color="blue"
              title={t('staticPages.childProgress.cards.milestone.title')}
              subtitle={t('staticPages.childProgress.cards.milestone.subtitle')}
              marginBottom={16}
              onClick={() => navigate('/childProgress/milestone-check')}
            />
            <KitoCard
              fullWidth
              image={VaccineGuardian}
              color="orange"
              title={t('staticPages.childProgress.cards.vaccine.title')}
              subtitle={t('staticPages.childProgress.cards.vaccine.subtitle')}
              onClick={() => navigate('/vaccination')}
            />
          </div>
        </div>
      )}
    </BaseLayout>
  );
}
